<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student_show,
                    },
                    {
                        name: $t('messages.other_contacts'),
                        href: meta.links.index,
                    },
                    {
                        name: contact.first_name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <AppButton element="inertia-link" :href="meta.links.edit">
                {{ $t('messages.edit') }}
            </AppButton>
            <ConfirmActionButton
                :href="meta.links.delete"
                v-if="meta.can.delete"
                method="delete"
                :confirm-text="$t('messages.delete')"
                :title="$t('messages.delete')"
                :button-text="$t('messages.delete')"
                danger
            />
        </div>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <div class="md:grid md:grid-cols-6 md:gap-6">
                <div class="md:col-span-6">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.name') }}
                    </label>
                    <div class="mt-1">
                        {{ contact.full_name }}
                    </div>
                </div>

                <div class="md:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.nationality') }}
                    </label>
                    <div class="mt-1">
                        {{ contact.nationality }}
                    </div>
                </div>

                <div class="md:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.email') }}
                    </label>
                    <div class="mt-1">
                        <a :href="`mailto:` + contact.email">
                            {{ contact.email }}
                        </a>
                    </div>
                </div>

                <div class="md:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.gender') }}
                    </label>
                    <div class="mt-1">
                        <span v-if="contact.gender">
                            {{ $t('messages.' + contact.gender) }}
                        </span>
                    </div>
                </div>

                <div class="md:col-span-2">
                    <label class="block text-sm font-medium leading-5 text-gray-700">
                        {{ $t('messages.identification_document') }}
                    </label>
                    <div class="mt-1">
                        {{ contact.identification_document }}
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $tc('messages.phones', 2) }}
            </template>
            <PhonesList :phones="contact.phones" />
        </TitleFieldsFormSection>

        <TitleFieldsFormSection>
            <template v-slot:title>
                {{ $tc('messages.students', 2) }}
            </template>
            <div class="md:grid md:grid-cols-2 md:gap-6">
                <div class="relative col-span-1 flex shadow rounded-md" v-for="student in contact.students">
                    <div
                        class="shrink-0 flex items-center justify-center w-16 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                    >
                        <a :href="student.links.show">
                            <img :src="student.avatar_or_default" alt="profile photo" />
                        </a>
                    </div>
                    <div
                        class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                    >
                        <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                            <a
                                :href="student.links.show"
                                class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                            >
                                {{ student.full_name }}
                                <CanTakeStudent :value="student.can_take_student"></CanTakeStudent>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </TitleFieldsFormSection>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import CanTakeStudent from '@/components/CanTakeStudent.vue';
import PhonesList from '@/Pages/Admin/Relatives/PhonesList.vue';
import AppButton from '@/components/AppButton.vue';
import ConfirmActionButton from '@/components/ConfirmActionButton.vue';

export default {
    components: {
        PanelPage,
        TitleFieldsFormSection,
        CanTakeStudent,
        PhonesList,
        AppButton,
        ConfirmActionButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['student', 'contact', 'meta'],
    data() {
        return {};
    },
};
</script>
